import { Component, OnInit, ViewChild, OnChanges, Input, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

import { GroupingService } from '@services/grouping.service';
import { Grouping } from '@classes/grouping/grouping';
import { UiService } from '@services/ui.service';
import { Subscription } from 'rxjs';
import { AuthService } from '@services/auth.service';

@Component({
    selector: 'app-groups-list',
    templateUrl: './groups-list.component.html',
    styleUrls: ['./groups-list.component.scss']
})
export class GroupsListComponent implements OnInit, OnChanges, OnDestroy {
    @Input() groups: Grouping[];
    @Input() isEditable = true;
    @Input() doesShowPublic = true;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    private loadingSub: Subscription;

    displayedColumns: string[] = ['name', 'region', 'length', 'createdBy'];
    dataSource: MatTableDataSource<Grouping>;
    systemName = 'SYSTEM';
    isLoading: boolean;
    userName: string;

    constructor(
        private compareSrv: GroupingService,
        private authSrv: AuthService,
        private uiSrv: UiService
    ) { }

    ngOnInit(): void {
        if(this.doesShowPublic) {
            this.displayedColumns.push('isPublic');
        }
        if(this.isEditable) {
            this.displayedColumns.push('actions');
        }
        this.userName = this.authSrv.getAuthUser().name;
    }

    ngOnChanges(): void {
        this.initSubscriptions();
        this.initTable();
    }

    onSelect(group: Grouping): void {
        this.compareSrv.selectedGroupChanged.next(group);
    }

    onAddGroup(): void {
        const newGroup = new Grouping();
        this.compareSrv.selectedGroupChanged.next(newGroup);
    }

    onDeleteGroup(group: Grouping): void {
        this.uiSrv.confirmDialog('main.dialogs.confirmDeleteGroup.summary').afterClosed()
        .subscribe((result: boolean) => {
            if(result) {
                this.isLoading = true;
                this.compareSrv.delete(group.code).subscribe(() => this.isLoading = false);
            }
        });
    }

    private initTable(): void {
        this.dataSource = new MatTableDataSource(this.groups);
        this.sortTable();
    }

    private sortTable(): void {
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'name': return item.text.shortLabel.toLowerCase();
                case 'region': return item.region.text.shortLabel.toLowerCase();
                case 'length': return item.organisms ? item.organisms.length : 0;
                default: return item[property];
            }
        };
        this.dataSource.sort = this.sort;
    }

    private initSubscriptions(): void {
        this.loadingSub = this.uiSrv.loadingStateChanged
            .subscribe(loadingState => {
                this.isLoading = loadingState;
            });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
